<div class="container-fluid" *ngIf="isLoggedIn">

  <div class="row">
    <div class="col-md-12 s-home text-center">

      <div class="row s-homebar w-100">
        <div class="col-md-3">
          <div class="s-round-lg mx-auto s-homebarbutton" (click)="openPage('CTL')">
            <button type="button" class="btn btn-default btn-lg"><i class="fa fa-book"></i></button>
            <span style="margin-left:10px; font-weight:bold;">{{customLabel('HOME', 'menuCAT')}}</span>
          </div>
        </div>
        <div class="col-md-3">
          <div class="s-round-lg mx-auto s-homebarbutton" (click)="openPage('SES')" *ngIf="hasStages">
            <button type="button" class="btn btn-default btn-lg"><i class="fa fa-atlas"></i></button>
            <span style="margin-left:10px; font-weight:bold;">{{customLabel('HOME', 'menuSES')}}</span>
          </div>
        </div>
        <div class="col-md-3">
          <div class="s-round-lg mx-auto s-homebarbutton" (click)="openPage('CYC')" *ngIf="hasCursus">
            <button type="button" class="btn btn-default btn-lg"><i class="fa fa-anchor"></i></button>
            <span style="margin-left:10px; font-weight:bold;">{{customLabel('HOME', 'menuCYC')}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row mt-3">
    <div class="col-md-12 text-center">
      <h1 class="basepage_maintitle">{{customLabel('HOME', 'welcome')}}</h1>
    </div>
  </div>

  <div class="row mt-5">
    <div class="col-12 text-center">
      <div class="panel panel-default">
        <div class="panel-body">
          <a class="btn btn-default btn-circle facebook socialnetwork mr-1" *ngIf="facebook !== ''" href="{{facebook}}" target="_blank">
            <i class="fab fa-facebook-f"></i>
          </a>
          <a class="btn btn-primary btn-circle twitter socialnetwork mr-1" *ngIf="twitter !== ''" href="{{twitter}}" target="_blank">
            <i class="fab fa-twitter"></i>
          </a>
          <a class="btn btn-success btn-circle linkedin socialnetwork mr-1" *ngIf="linkedin !== ''" href="{{linkedin}}" target="_blank">
            <i class="fab fa-linkedin-in"></i>
          </a>
          <a class="btn btn-info btn-circle viadeo socialnetwork mr-1" *ngIf="viadeo !== ''" href="{{viadeo}}" target="_blank">
            <i class="fab fa-viadeo"></i>
          </a>
        </div>
      </div>
    </div>
  </div>
</div>


<!-- Modal -->
<div id="modalMxg"  *ngIf="!isLoggedIn">
  <div>
    <h1 class="text-center">{{store.loginError}}</h1>
  </div>
</div>
